import $$ from 'cmn-utils'

const baseUrl = "/api/inspect/task/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    inspectDevice:(params)=>{
        return $$.get(baseUrl+'device/list',params)
    },
    inspectDeviceDetail:(params)=>{
        return $$.get(baseUrl+'device/get',params)
    },
    submit:(params)=>{
        return $$.post(baseUrl+'device/submit',params)
    },
    personal: {
        list: (params) => {
            return $$.get(baseUrl + 'personal/list', params)
        },
    }

}